export const getCivilStatuses = () => ([
    'divorced',
    'married',
    'not married',
    'partner',
    'registered partner',
    'separated',
    'widow'
]);
